import { render } from "./UploadImage.vue?vue&type=template&id=4e85fff8"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/callum/Dev/saxton/saxton-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__